<div class="recruitment-page">
  <section class="recruitment-shell">
    <div class="recruitment-tabs">
      <h1>Recruitment</h1>
      <button mat-button type="button" [class.active]="activeView === 'upload'" (click)="showView('upload')">
        <mat-icon>upload_file</mat-icon>
        {{ canUseRecruitmentAdminActions ? 'Resume Upload' : 'Assigned Interviews' }}
      </button>
      <button mat-button type="button" *ngIf="canUseRecruitmentAdminActions" [class.active]="activeView === 'export'" (click)="showView('export')">
        <mat-icon>table_view</mat-icon>
        Excel Preview
      </button>
    </div>

    <main class="recruitment-content">
      <section *ngIf="activeView === 'upload'" class="panel">
        <!-- <div class="page-heading">
          <div>
            <h1>{{ canUseRecruitmentAdminActions ? 'Upload Resume' : 'Assigned Interviews' }}</h1>
            <p>{{ canUseRecruitmentAdminActions ? 'Upload single or multiple resumes. Parsed candidate data is shown below.' : 'Only candidates assigned to you are shown below.' }}</p>
          </div>
        </div> -->

        <ng-container *ngIf="canUseRecruitmentAdminActions">
          <div class="collapsible-heading">
            <div>
              <h2>Resume Upload</h2>
              <p>Upload and parse candidate resumes.</p>
            </div>
            <button mat-stroked-button type="button" (click)="toggleResumeUpload()">
              <mat-icon>{{ isResumeUploadExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
              {{ isResumeUploadExpanded ? 'Hide' : 'Show' }}
            </button>
          </div>

          <div class="upload-compact-grid" *ngIf="isResumeUploadExpanded">
            <div class="upload-zone" (click)="resumeFileInput.click()">
              <input #resumeFileInput type="file" hidden [multiple]="uploadMode === 'multiple'" accept=".pdf,.doc,.docx" (change)="onResumeSelected($event)">
              <mat-icon>cloud_upload</mat-icon>
              <strong>Drag & drop files here</strong>
              <button mat-raised-button color="primary" type="button" (click)="$event.stopPropagation(); resumeFileInput.click()">Browse Files</button>
              <small>PDF, DOC, DOCX | Max 10 MB per file</small>
            </div>

            <div class="upload-side">
              <div class="upload-mode">
                <span>Upload Mode</span>
                <!-- <mat-radio-group [(ngModel)]="uploadMode">
                  <mat-radio-button value="single">Single File</mat-radio-button>
                  <mat-radio-button value="multiple">Multiple Files</mat-radio-button>
                </mat-radio-group> -->
              </div>

              <div class="list-heading">Uploaded Files ({{ uploadedFiles.length }})</div>
              <div class="file-list compact-list">
                <div class="file-row" *ngFor="let file of uploadedFiles">
                  <div class="file-name">
                    <mat-icon>picture_as_pdf</mat-icon>
                    <span>{{ file.name }}</span>
                  </div>
                  <span>{{ file.size }}</span>
                  <span class="pill uploaded">{{ file.status }}</span>
                  <button mat-icon-button type="button" matTooltip="Remove file" (click)="removeResumeFile(file.id)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>

              <div class="actions-row compact-actions">
                <button mat-stroked-button type="button" (click)="resetUploads()">Reset</button>
                <button mat-raised-button color="primary" type="button" (click)="uploadAndParse()">Upload & Parse</button>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="candidate-list-section" #candidateListSection>
        <div class="page-heading">
          <div>
            <h1>{{ canUseRecruitmentAdminActions ? 'Employee List' : 'Assigned Candidate List' }}</h1>
          </div>
        </div>

        <div class="stat-grid" *ngIf="canUseRecruitmentAdminActions">
          <div class="stat-card">
            <mat-icon>groups</mat-icon>
            <span>Total Candidates</span>
            <strong>{{ totalCandidates }}</strong>
          </div>
          <div class="stat-card blue">
            <mat-icon>person_search</mat-icon>
            <span>Reviewed</span>
            <strong>{{ reviewedCount }}</strong>
          </div>
          <div class="stat-card amber">
            <mat-icon>record_voice_over</mat-icon>
            <span>Interviewed</span>
            <strong>{{ interviewedCount }}</strong>
          </div>
          <div class="stat-card green">
            <mat-icon>person_add</mat-icon>
            <span>Offered</span>
            <strong>{{ offeredCount }}</strong>
          </div>
          <div class="stat-card red">
            <mat-icon>person_remove</mat-icon>
            <span>Rejected</span>
            <strong>{{ rejectedCount }}</strong>
          </div>
        </div>

        <div class="filters">
          <mat-form-field appearance="outline">
            <mat-label>Search by name, email, phone</mat-label>
            <input matInput [(ngModel)]="searchText"(keyup.enter)="applyFilters()">
            <mat-icon matPrefix>search</mat-icon>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select [(ngModel)]="statusFilter" (selectionChange)="applyFilters()">
              <mat-option value="All">All</mat-option>
              <mat-option *ngFor="let option of statusOptions" [value]="option.value">{{ option.label }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button type="button" (click)="clearFilters()">Reset</button>
        </div>

        <div class="table-wrap">
          <table mat-table [dataSource]="filteredCandidates">
            <ng-container matColumnDef="index">
              <th mat-header-cell *matHeaderCellDef>#</th>
              <td mat-cell *matCellDef="let candidate; let i = index">{{ candidatePageIndex * candidatePageSize + i + 1 }}</td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let candidate">{{ candidate.name }}</td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Email</th>
              <td mat-cell *matCellDef="let candidate">{{ candidate.email }}</td>
            </ng-container>
            <ng-container matColumnDef="contactNumber">
              <th mat-header-cell *matHeaderCellDef>Contact Number</th>
              <td mat-cell *matCellDef="let candidate">{{ candidate.contactNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="experience">
              <th mat-header-cell *matHeaderCellDef>Experience</th>
              <td mat-cell *matCellDef="let candidate">{{ candidate.experience }}</td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let candidate">
                <span class="pill" [ngClass]="getStatusClass(candidate.status)">{{ getStatusLabel(candidate.status) }}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let candidate">
                <div class="action-buttons">
                  <button mat-icon-button type="button" matTooltip="Edit review" (click)="openCandidate(candidate)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button type="button" *ngIf="canUseRecruitmentAdminActions" matTooltip="Documents" [disabled]="!canManageDocuments(candidate.status)" (click)="openDocuments(candidate)">
                    <mat-icon>folder_open</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>

        <div class="table-footer">Showing {{ candidateStart }} to {{ candidateEnd }} of {{ totalRecords }} entries</div>
        <mat-paginator
          [length]="totalRecords"
          [pageIndex]="candidatePageIndex"
          [pageSize]="candidatePageSize"
          [pageSizeOptions]="[5, 10, 25, 50]"
          showFirstLastButtons
          (page)="onCandidatePageChange($event)">
        </mat-paginator>
        </div>
      </section>

      <section *ngIf="activeView === 'review' && selectedCandidate" class="panel review-layout">
        <aside class="candidate-card">
          <button mat-button type="button" (click)="showView('upload')">
            <mat-icon>arrow_back</mat-icon>
            Back to Candidates
          </button>
          <div class="avatar">{{ selectedCandidate.name.charAt(0) }}</div>
          <h2>{{ selectedCandidate.name }}</h2>
          <p>{{ selectedCandidate.email }}</p>
          <p>{{ selectedCandidate.contactNumber }}</p>
        </aside>

        <div class="review-content">
          <div class="parsed-card">
            <div class="sub-heading">
              <h2>Parsed Information <small>(Auto Extracted)</small></h2>
            </div>
            <div class="info-grid">
              <label>Full Name<span>{{ selectedCandidate.name }}</span></label>
              <!-- <label>Source of Resume/CV<span>{{ selectedCandidate.sourceOfResume || '-' }}</span></label> -->
              <!-- <label>CV Uploaded On<span>{{ selectedCandidate.cvUploadedOn || '-' }}</span></label> -->
              <label>Email<span>{{ selectedCandidate.email }}</span></label>
              <label>Contact Number<span>{{ selectedCandidate.contactNumber }}</span></label>
              <label>Total Experience<span>{{ selectedCandidate.experience }}</span></label>
              <label>Current Company<span>{{ selectedCandidate.currentCompany }}</span></label>
              <label>Skills<span>{{ selectedCandidate.skills }}</span></label>
              <label>Tech Stack<span>{{ selectedCandidate.techStack }}</span></label>
              <label>Education<span>{{ selectedCandidate.education }}</span></label>
            </div>
          </div>

          <form class="review-form" [formGroup]="candidateForm" (ngSubmit)="saveCandidate()">
            <h2>Review & Update</h2>
            <div class="review-field-cards">
              <div class="review-field-card">
                <h3>Assignment & Schedule</h3>
                <div class="form-grid">
                  <mat-form-field appearance="outline">
                    <mat-label>Assigned HR</mat-label>
                    <mat-select formControlName="reviewedBy">
                      <mat-option value="">Select HR</mat-option>
                      <mat-option *ngFor="let user of hrUsers" [value]="getUserDisplayName(user)">
                        {{ getUserDisplayName(user) }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Source of Resume/CV</mat-label>
                    <input matInput formControlName="sourceOfResume" placeholder="Enter source">
                  </mat-form-field>
                  <mat-form-field appearance="outline" *ngIf="!isPostOfferFlow">
                    <mat-label>Department</mat-label>
                    <mat-select formControlName="departmentId">
                      <mat-option value="">Select Department</mat-option>
                      <mat-option *ngFor="let department of departments" [value]="department.id">
                        {{ department.departmentName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>CV Uploaded On</mat-label>
                    <input matInput [matDatepicker]="cvUploadedOnPicker" formControlName="cvUploadedOn" placeholder="DD-MM-YYYY" readonly>
                    <mat-datepicker-toggle matIconSuffix [for]="cvUploadedOnPicker" [disabled]="true"></mat-datepicker-toggle>
                    <mat-datepicker #cvUploadedOnPicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="review-field-card">
                <h3>luation Details</h3>
                <div class="form-grid secondary-grid">
                  <mat-form-field appearance="outline">
                    <mat-label>Interview Date</mat-label>
                    <input matInput [matDatepicker]="reviewedOnPicker" formControlName="reviewedOn" placeholder="DD-MM-YYYY">
                    <mat-datepicker-toggle matIconSuffix [for]="reviewedOnPicker"></mat-datepicker-toggle>
                    <mat-datepicker #reviewedOnPicker></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>{{ getInterviewerLabel() }}</mat-label>
                    <mat-select formControlName="interviewerName">
                      <mat-option value="">Select Employee</mat-option>
                      <mat-option *ngFor="let user of getInterviewerOptions()" [value]="getUserDisplayName(user)">
                        {{ getUserDisplayName(user) }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" *ngIf="!isPostOfferFlow">
                    <mat-label>Interview Round</mat-label>
                    <mat-select formControlName="interviewRound">
                      <mat-option *ngFor="let round of interviewRoundOptions" [value]="round">{{ round }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="status">
                      <mat-option *ngIf="isPostOfferFlow && selectedCandidate?.status === 'OFFERED'" value="OFFERED" disabled>Offered</mat-option>
                      <mat-option *ngFor="let option of getReviewStatusOptions()" [value]="option.value">{{ option.label }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" *ngIf="showInterviewerFeedbackFields">
                    <mat-label>Overall Percentage</mat-label>
                    <input matInput type="text" inputmode="numeric" maxlength="3" formControlName="overallPercentage" placeholder="Out of 100" (input)="onOverallPercentageInput($event)">
                    <mat-error *ngIf="candidateForm.get('overallPercentage')?.hasError('min') || candidateForm.get('overallPercentage')?.hasError('max') || candidateForm.get('overallPercentage')?.hasError('pattern')">
                      Enter a number from 0 to 100.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" *ngIf="showInterviewerFeedbackFields">
                    <mat-label>Recommendation Status</mat-label>
                    <mat-select formControlName="recommendationStatus">
                      <mat-option value="">Select Recommendation</mat-option>
                      <mat-option *ngFor="let option of recommendationStatusOptions" [value]="option.value">{{ option.label }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="candidateForm.get('recommendationStatus')?.hasError('required')">
                      Recommendation is required.
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="wide">
                    <mat-label>Remarks</mat-label>
                    <textarea matInput rows="3" formControlName="remarks"></textarea>
                    <mat-error *ngIf="candidateForm.get('remarks')?.hasError('required')">
                      Remarks are required.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="actions-row">
              <button mat-stroked-button type="button" (click)="showView('upload')">Cancel</button>
              <button mat-raised-button color="primary" type="submit">Save</button>
            </div>
          </form>

          <div class="history-section">
            <h2>Change History</h2>
            <div class="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Interview Round</th>
                    <th>Interviewer Name</th>
                    <th>Remarks</th>
                    <th>Responsible Person</th>
                    <th>Changed On</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of candidateHistory">
                    <td>{{ row.status || '-' }}</td>
                    <td>{{ getHistoryField(row, 'Interview Round') }}</td>
                    <td>{{ getHistoryField(row, 'Interviewer Name') }}</td>
                    <td>{{ getHistoryRemarks(row) }}</td>
                    <td>{{ getUserNameById(row.responsiblePerson) }}</td>
                    <td>{{ getHistoryChangedOn(row) }}</td>
                  </tr>
                  <tr *ngIf="candidateHistory.length === 0">
                    <td colspan="6">
                      <div class="empty-state compact">
                        <mat-icon>history</mat-icon>
                        <p>No change history found.</p>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section *ngIf="activeView === 'export'" class="panel export-panel">
        <div class="page-heading">
          <div>
            <h1>Export Candidates to Excel</h1>
            <p>Preview of data that will be exported.</p>
          </div>
          <button mat-raised-button color="primary" type="button" (click)="exportToExcel()">
            <mat-icon>download</mat-icon>
            Export to Excel
          </button>
        </div>

        <div class="export-filters">
          <mat-form-field appearance="outline">
            <mat-label>Search export records</mat-label>
            <input matInput [(ngModel)]="exportSearchText" (ngModelChange)="applyExportSearch()">
            <mat-icon matPrefix>search</mat-icon>
          </mat-form-field>
          <div class="round-tabs">
            <button mat-stroked-button type="button" [class.active]="roundFilter === 'All'" (click)="setRoundFilter('All')">All</button>
            <button mat-stroked-button type="button" [class.active]="roundFilter === 'Round 1'" (click)="setRoundFilter('Round 1')">Round 1</button>
            <button mat-stroked-button type="button" [class.active]="roundFilter === 'Round 2'" (click)="setRoundFilter('Round 2')">Round 2</button>
            <button mat-stroked-button type="button" [class.active]="roundFilter === 'Round 3'" (click)="setRoundFilter('Round 3')">Round 3</button>
          </div>
        </div>

        <div class="excel-preview">
          <table mat-table [dataSource]="pagedChangeHistory">
            <ng-container matColumnDef="candidateName">
              <th mat-header-cell *matHeaderCellDef>Candidate</th>
              <td mat-cell *matCellDef="let row">{{ row.candidateName }}</td>
            </ng-container>
            <ng-container matColumnDef="sourceOfResume">
              <th mat-header-cell *matHeaderCellDef>Source</th>
              <td mat-cell *matCellDef="let row">{{ getHistoryField(row, 'Source of Resume/CV') }}</td>
            </ng-container>
            <ng-container matColumnDef="department">
              <th mat-header-cell *matHeaderCellDef>Department</th>
              <td mat-cell *matCellDef="let row">{{ getHistoryDepartment(row) }}</td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let row">{{ row.status || '-' }}</td>
            </ng-container>
            <ng-container matColumnDef="interviewRound">
              <th mat-header-cell *matHeaderCellDef>Interview Round</th>
              <td mat-cell *matCellDef="let row">{{ getHistoryField(row, 'Interview Round') }}</td>
            </ng-container>
            <ng-container matColumnDef="interviewerName">
              <th mat-header-cell *matHeaderCellDef>Interviewer Name</th>
              <td mat-cell *matCellDef="let row">{{ getHistoryField(row, 'Interviewer Name') }}</td>
            </ng-container>
            <ng-container matColumnDef="overallPercentage">
              <th mat-header-cell *matHeaderCellDef>Percentage</th>
              <td mat-cell *matCellDef="let row">{{ getHistoryField(row, 'Overall Percentage') }}</td>
            </ng-container>
            <ng-container matColumnDef="recommendationStatus">
              <th mat-header-cell *matHeaderCellDef>Recommendation</th>
              <td mat-cell *matCellDef="let row">{{ getHistoryField(row, 'Recommendation Status') }}</td>
            </ng-container>
            <ng-container matColumnDef="remarks">
              <th mat-header-cell *matHeaderCellDef>Remarks</th>
              <td mat-cell *matCellDef="let row">{{ getHistoryRemarks(row) }}</td>
            </ng-container>
            <ng-container matColumnDef="responsiblePerson">
              <th mat-header-cell *matHeaderCellDef>Responsible Person</th>
              <td mat-cell *matCellDef="let row">{{ getUserNameById(row.responsiblePerson) }}</td>
            </ng-container>
            <ng-container matColumnDef="createdDate">
              <th mat-header-cell *matHeaderCellDef>Changed On</th>
              <td mat-cell *matCellDef="let row">{{ getHistoryChangedOn(row) }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="previewColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: previewColumns;"></tr>
          </table>
        </div>

        <strong>Total Records: {{ filteredChangeHistory.length }}</strong>
        <mat-paginator
          [length]="filteredChangeHistory.length"
          [pageIndex]="exportPageIndex"
          [pageSize]="exportPageSize"
          [pageSizeOptions]="[5, 10, 25, 50]"
          showFirstLastButtons
          (page)="onExportPageChange($event)">
        </mat-paginator>
        <div class="actions-row">
          <button mat-stroked-button type="button" (click)="showView('upload')">Cancel</button>
        </div>
      </section>

      <section *ngIf="activeView === 'documents' && selectedDocumentCandidate" class="panel documents-panel">
        <button mat-button type="button" (click)="showView('upload')">
          <mat-icon>arrow_back</mat-icon>
          Back to Candidates
        </button>

        <ng-container *ngIf="selectedDocumentCandidate as documentCandidate">
          <div class="success-banner">
            <mat-icon>check_circle</mat-icon>
            {{ getStatusLabel(documentCandidate.status) }} candidate. Upload MSA or supporting documents.
          </div>

          <div class="document-workspace">
            <div class="document-candidate-summary">
              <span>Candidate</span>
              <h1>{{ documentCandidate.name }}</h1>
              <p>{{ documentCandidate.email }} | {{ documentCandidate.contactNumber }}</p>
            </div>

            <div>
              <h2>Upload MSA / Documents</h2>
              <div class="upload-zone compact document-upload-zone" (click)="documentFileInput.click()">
                <input #documentFileInput type="file" hidden multiple accept=".pdf,.doc,.docx" (change)="onDocumentsSelected($event)">
                <mat-icon>cloud_upload</mat-icon>
                <strong>Drag & drop documents here</strong>
                <button mat-stroked-button color="primary" type="button" (click)="$event.stopPropagation(); documentFileInput.click()">Browse Files</button>
                <small>PDF, DOC, DOCX | Max 10 MB</small>
              </div>
            </div>
          </div>

          <div class="list-heading">Uploaded Documents ({{ documentCandidate.msaDocuments.length }})</div>
          <div class="file-list">
            <div class="file-row" *ngFor="let document of documentCandidate.msaDocuments">
              <div class="file-name">
                <mat-icon>picture_as_pdf</mat-icon>
                <span>{{ document.name }}</span>
              </div>
              <span>{{ document.size }}</span>
              <button mat-icon-button type="button" matTooltip="Download document" (click)="downloadMsaDocument(document)">
                <mat-icon>download</mat-icon>
              </button>
              <button mat-icon-button type="button" matTooltip="Remove document" (click)="removeMsaDocument(document.id)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </ng-container>
      </section>

    </main>
  </section>
</div>
